module.exports = __webpack_public_path__ + "img/标准化制修订流程图.1ae908b9.png";